module.exports = __webpack_public_path__ + "images/tr_wework/ic-failed@1x-95d806acb50e19621ae36a9e3c70fa5c.png";